import { canViewFullExpansionConstructionContractFields } from "./commercialRoleAccess";
import { canViewerPermission, getViewerEmailFromStorage } from "./userMatrixStorage";
import { isPluginEnabled, PLUGIN_IDS } from "./registry";

export const CONTRACT_STATUS_OPTIONS = [
  { value: "pending_award", label: "Pending Award" },
  { value: "awarded", label: "Awarded" },
  { value: "cancelled", label: "Cancelled" },
];

export function contractsPluginEnabled() {
  return isPluginEnabled(PLUGIN_IDS.CONTRACTS);
}

export function canViewContracts(viewerEmail) {
  if (!contractsPluginEnabled()) return false;
  const email = viewerEmail ?? getViewerEmailFromStorage();
  if (canViewerPermission(email, "canAccessContracts", false)) return true;
  return canViewFullExpansionConstructionContractFields(email);
}

export function canManageContracts(viewerEmail) {
  return canViewContracts(viewerEmail);
}

export function contractStatusLabel(status) {
  const hit = CONTRACT_STATUS_OPTIONS.find((o) => o.value === status);
  return hit?.label ?? String(status || "—");
}

export function contractStatusClass(status) {
  if (status === "awarded") return "contracts-status--awarded";
  if (status === "cancelled") return "contracts-status--cancelled";
  return "contracts-status--pending";
}

export function formatContractCost(value) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  return Number(value).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  });
}

export function formatSignedContractCost(value) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  const n = Number(value);
  const abs = Math.abs(n).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  });
  if (n > 0) return `+${abs}`;
  if (n < 0) return `-${abs}`;
  return abs;
}

export function getContractsViewerEmail() {
  return getViewerEmailFromStorage();
}
